/*
  Tapticle cart drawer enhancements — additive, deferred, no rewrite of
  Dawn's cart JS. Dawn's cart.js / cart-drawer.js still own qty updates,
  the AJAX re-render, focus trap, ESC and ATC-opens-drawer. This only:
  - adds a leave class to a line item the moment its remove button is
    pressed, so the row visibly fades before Dawn re-renders the section
    (CSS gates the transition behind prefers-reduced-motion, so it's
    instant for users who opt out)
  - mirrors the live cart item count onto an aria-live region so screen
    readers hear the count change after add/remove
*/
(() => {
  'use strict';

  // 1. Remove-button leave animation
  document.addEventListener('click', (event) => {
    const removeBtn = event.target.closest('cart-remove-button');
    if (!removeBtn) return;
    const item = removeBtn.closest('.cart-item');
    if (item) item.classList.add('tt-removing');
  });

  // 2. aria-live cart count — announce updates from Dawn's bubble
  const bubble = document.querySelector('#cart-icon-bubble');
  if (!bubble) return;

  let live = document.getElementById('tt-cart-live');
  if (!live) {
    live = document.createElement('span');
    live.id = 'tt-cart-live';
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
  }

  const readCount = () => {
    const el = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    return el ? el.textContent.trim() : '0';
  };

  let last = readCount();
  const observer = new MutationObserver(() => {
    const now = readCount();
    if (now !== last) {
      last = now;
      live.textContent = window.cartStrings?.itemsInCart
        ? `${now} ${window.cartStrings.itemsInCart}`
        : `Cart updated: ${now} item${now === '1' ? '' : 's'}`;
    }
  });
  observer.observe(bubble, { childList: true, subtree: true, characterData: true });
})();
